/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1365
 */

"use strict"

var r = require(/* 765 */"./765/index")
module.exports = function (e) {
  r.copy(e, this)
}
